import get from 'lodash/get'
import { convertHexToRgbA } from 'shared/helper'

export const getCategoryStyle = (themeColorHex, categoryTheme, cssClass) => {

  const classicSelectedCSS = {
    tab: {
      color: themeColorHex,
      borderBottomWidth: "0.2rem",
      borderBottomStyle: "solid",
      borderBottomColor: themeColorHex
    },
    link: {
      color: themeColorHex
    }
  }

  const defaultTabCss = {
    link: {
      color: "#666"
    }
  }

  const tabSelectedCSS = {
    tab: {
      background: themeColorHex,
      borderRadius: "0.8rem 0.8rem 0 0",
      color: "#ffffff"
    },
    link: {
      color: "#ffffff",
    }
  }

  const tabHoverCSS = {
    link: { color: "#666" },
    tab: {
      background: convertHexToRgbA(themeColorHex, 0.15),
      borderRadius: "0.8rem 0.8rem 0 0"
    }
  }

  const CATEGORY_STYLE =  {
    tab: {
      category: {
        default: defaultTabCss,
        selected: tabSelectedCSS,
        hover: tabHoverCSS
      },
      parentCategory: {
        selected: tabSelectedCSS,
        hover: tabHoverCSS
      },
      linkCategory: {
        hover: tabHoverCSS
      },
      subcategory: {
        selected: {
          tab: {color: themeColorHex}
        },
        default: {
          link: { color: "#666"}
        },
        hover: {
          tab: {
            background: convertHexToRgbA(themeColorHex, 0.15),
          },
          link: {
            color: "#666"
          }
        }
      },
      categoriesRenderer: {
        borderBottom: "solid 0.2rem " + themeColorHex
      }
    },
    classic: {
      subcategory: {
        selected: classicSelectedCSS
      },
      parentCategory: {
        selected: classicSelectedCSS
      },
      category: {
        selected: classicSelectedCSS
      }
    }
  }

  return get(CATEGORY_STYLE, categoryTheme + "." + cssClass ,{}) 
}

export const getArrowCSS = (themeColorHex) => {
  return {
      enabled: {color: themeColorHex},
      disabled: {color: convertHexToRgbA(themeColorHex, 0.25)} 
  }
}